import { getTheme, mergeStyles, Stack, Text } from '@fluentui/react';
import React from 'react';
import { BwjSpinner } from '../bwj-spinner';

interface IBwjSpinnerLabelProps {
    text?: string;
}

export const BwjSpinnerLabel: React.FunctionComponent<IBwjSpinnerLabelProps> = (props) => {
  const theme = getTheme();
  const stackItemStyles = mergeStyles({
    flexGrow: 1,
  });

  return !!props.text ? (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: '5px', padding: '5px' }}>
      <BwjSpinner size={theme.fonts.small.fontSize} />
      <Text variant="small" className={stackItemStyles}>
        {props.text}
      </Text>
    </Stack>
  ) : null;
};
